import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, MessageCircle } from 'lucide-react';
import { toast } from 'sonner';
import FloatingContactWidget from '@/components/FloatingContactWidget';

const Footer = () => {
  const { t } = useTranslation();

  const handleCopyWeChat = () => {
    navigator.clipboard.writeText('0358496681');
    toast.success('Đã sao chép ID WeChat: 0358496681');
  };

  return (
    <footer className="bg-gray-900 text-white relative">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4 bg-gradient-to-r from-blue-400 to-cyan-300 bg-clip-text text-transparent">
              {t('footer.company')}
            </h3>
            <p className="text-gray-400 mb-4">
              {t('about.content')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-blue-400 transition-colors">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-400 hover:text-blue-400 transition-colors">
                  {t('nav.products')}
                </Link>
              </li>
              <li>
                <Link to="/news" className="text-gray-400 hover:text-blue-400 transition-colors">
                  {t('nav.news')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-blue-400 transition-colors">
                  {t('nav.contact')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">{t('footer.contactHeader')}</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3 text-gray-400">
                <MapPin size={20} className="text-blue-400 flex-shrink-0 mt-1" />
                <span>{t('footer.address')}</span>
              </li>
              <li className="flex items-center space-x-3 text-gray-400 font-semibold text-blue-300">
                <span className="bg-blue-900/60 text-blue-300 border border-blue-700/60 text-xs px-2.5 py-1 rounded">
                  {t('footer.taxCode')}
                </span>
              </li>
              <li className="flex items-center space-x-3 text-gray-400">
                <Phone size={20} className="text-blue-400 flex-shrink-0" />
                <a href="tel:0907811577" className="hover:text-blue-400 transition-colors font-bold text-white">
                  0907 811 577
                </a>
              </li>
              <li className="flex items-start space-x-3 text-gray-400">
                <MessageCircle size={20} className="text-emerald-400 flex-shrink-0 mt-1" />
                <div className="flex flex-wrap items-center gap-1.5 text-xs">
                  <a
                    href="https://zalo.me/0907811577"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-blue-400 hover:border-blue-500/50 bg-gray-800/80 px-2.5 py-1 rounded-md border border-gray-700/60 transition-colors whitespace-nowrap"
                  >
                    Zalo: <span className="font-semibold text-white">0907 811 577</span>
                  </a>
                  <a
                    href="https://wa.me/84907811577"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-emerald-400 hover:border-emerald-500/50 bg-gray-800/80 px-2.5 py-1 rounded-md border border-gray-700/60 transition-colors whitespace-nowrap"
                  >
                    WhatsApp: <span className="font-semibold text-white">0907 811 577</span>
                  </a>
                  <button
                    onClick={handleCopyWeChat}
                    className="hover:text-emerald-300 hover:border-emerald-400/50 bg-gray-800/80 px-2.5 py-1 rounded-md border border-gray-700/60 transition-colors whitespace-nowrap text-left cursor-pointer"
                    title="Ấn để sao chép ID WeChat"
                  >
                    WeChat: <span className="font-semibold text-emerald-300">0358496681</span>
                  </button>
                </div>
              </li>
              <li className="flex items-center space-x-3 text-gray-400">
                <Mail size={20} className="text-blue-400 flex-shrink-0" />
                <a href="mailto:ctytanhungthinh2024@gmail.com" className="hover:text-blue-400 transition-colors">
                  ctytanhungthinh2024@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} Tân Hưng Thịnh. All rights reserved.</p>
        </div>
      </div>

      {/* Floating Action Buttons */}
      <FloatingContactWidget />
    </footer>
  );
};

export default Footer;
